module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/estabelecimentos/modal-token/modal-token.component.scss
// module id = ./src/app/estabelecimentos/modal-token/modal-token.component.scss
// module chunks = main